const is = () => {
  const { STAGE } = process.env;

  return {
    dev: STAGE === 'development',
    prod: STAGE === 'production',
    stage: STAGE === 'staging',
    nonprod: STAGE === 'development' || STAGE === 'staging',
  };
};

export const isIE = () => {
  const ua = window.navigator.userAgent;
  const msie = ua.indexOf('MSIE ');

  if (msie > 0) {
    return true;
  }

  const trident = ua.indexOf('Trident/');

  if (trident > 0) {
    return true;
  }

  const edge = ua.indexOf('Edge/');

  if (edge > 0) {
    return true;
  }

  return false;
};

export const isFirefox = window.navigator.userAgent.toLowerCase().includes('firefox');

export const isSafari = /safari/i.test(window.navigator.userAgent) && !/chrome/i.test(window.navigator.userAgent);

export const isTablet = () => document.body.clientWidth < 1025 && document.body.clientWidth > 767;

export const isMobile = () => /android|webos|iphone|ipad|ipod|blackberry|bb|playbook|iemobile|windows phone|kindle|silk|opera mini/i.test(
  window.navigator.userAgent
);

export default is;
